// src/fonts/registerRoboto.js
import { RobotoRegular } from "./Roboto-Regular";
import { CaveatRegular } from "./Caveat-Regular";
import { DancingScriptRegular } from "./DancingScript-Regular";
import { DosisLight } from "./Dosis-Light";
import { IndieFlowerRegular } from "./IndieFlower-Regular";
import { LibertinusSerifDisplayRegular } from "./LibertinusSerifDisplay-Regular";
import { QuicksandRegular } from "./Quicksand-Regular";
import { StoryScriptRegular } from "./StoryScript-Regular";

export function registerRoboto(doc) {
  // Roboto
  //doc.addFileToVFS("Roboto-Regular.ttf", RobotoRegular);
  //doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");

  // Caveat
  doc.addFileToVFS("Caveat-Regular.ttf", CaveatRegular);
  doc.addFont("Caveat-Regular.ttf", "Caveat", "normal");

  // Dancing Script
  doc.addFileToVFS("DancingScript-Regular.ttf", DancingScriptRegular);
  doc.addFont("DancingScript-Regular.ttf", "DancingScript", "normal");

  // Dosis
  doc.addFileToVFS("Dosis-Light.ttf", DosisLight);
  doc.addFont("Dosis-Light.ttf", "Dosis", "normal");

  // Indie Flower
  doc.addFileToVFS("IndieFlower-Regular.ttf", IndieFlowerRegular);
  doc.addFont("IndieFlower-Regular.ttf", "IndieFlower", "normal");

  // Libertinus Serif Display
  doc.addFileToVFS("LibertinusSerifDisplay-Regular.ttf", LibertinusSerifDisplayRegular);
  doc.addFont("LibertinusSerifDisplay-Regular.ttf", "LibertinusSerifDisplay", "normal");

  // Quicksand
  doc.addFileToVFS("Quicksand-Regular.ttf", QuicksandRegular);
  doc.addFont("Quicksand-Regular.ttf", "Quicksand", "normal");

  // Story Script
  doc.addFileToVFS("StoryScript-Regular.ttf", StoryScriptRegular);
  doc.addFont("StoryScript-Regular.ttf", "StoryScript", "normal");
}
